module.exports = __webpack_public_path__ + "fonts/FSSinclair-Light.b0940523.otf";